import {Mesh, BoxGeometry, MeshPhongMaterial, Color} from "three";
import { mergeBufferGeometries } from 'three/examples/jsm/utils/BufferGeometryUtils.js';

const createCabinet = function(width,height,depth,color) {
    const blueGlassMaterial = new MeshPhongMaterial({
        color: new Color(color),
        opacity: 1,
        transparent: true,
        depthWrite: false,//避免两个有透明度物体视线重叠时透明
    });

    const leftPanelGeo = new BoxGeometry(2, height, depth); //箱左侧，厚2，高88，长40
    const leftPanel = new Mesh(leftPanelGeo, blueGlassMaterial);
    leftPanel.name = 'leftPanel';
    leftPanel.position.set(width / 2 - 1, height / 2, 0);

    const rightPanelGeo = new BoxGeometry(2, height, depth); //箱右侧，厚2，高88，长40
    const rightPanel = new Mesh(rightPanelGeo, blueGlassMaterial);
    rightPanel.name = 'rightPanel';
    rightPanel.position.set(-width / 2 + 1, height / 2, 0);


    const behindPanelGeo = new BoxGeometry(width - 4, height, 2); //后板宽26，高88，厚2
    const behindPanel = new Mesh(behindPanelGeo, blueGlassMaterial);
    behindPanel.name = 'behindPanel';
    behindPanel.position.set(0, height / 2, 0 - depth / 2 + 1);

    const topPanelGeo = new BoxGeometry(width, 2, depth);
    const topPanel = new Mesh(topPanelGeo, blueGlassMaterial);
    topPanel.name = 'topPanel';
    topPanel.position.set(0, height, 0);

    // 更新投影矩阵，不更新各mesh位置会不正确
    leftPanel.updateMatrix();
    rightPanel.updateMatrix();
    behindPanel.updateMatrix();
    topPanel.updateMatrix();
    // 更新后的矩阵，重新转换为几何体，此时，几何体位置才正确
    leftPanel.geometry.applyMatrix4(leftPanel.matrix);
    rightPanel.geometry.applyMatrix4(rightPanel.matrix);
    behindPanel.geometry.applyMatrix4(behindPanel.matrix);
    topPanel.geometry.applyMatrix4(topPanel.matrix);
    const mergedGeometry = mergeBufferGeometries(
        [
            leftPanel.geometry,
            rightPanel.geometry,
            behindPanel.geometry,
            topPanel.geometry,
        ],
        true
    );
    const cab = new Mesh(mergedGeometry, [
        leftPanel.material,
        rightPanel.material,
        behindPanel.material,
        topPanel.material,
    ]);
    cab.name = 'cabinet';
    cab.castShadow = true;
    cab.receiveShadow = true;

    // const menGeo = new BoxGeometry(width, height + 1, 1); //机箱们宽，高，厚
    // // 平移几何体，改变旋转轴
    // menGeo.translate(-width / 2, 0, 0);
    // const men = new Mesh(menGeo, [
    //     new MeshLambertMaterial({ color: 0x999999 }),
    //     new MeshLambertMaterial({ color: 0x999999 }),
    //     new MeshLambertMaterial({ color: 0x999999 }),
    //     new MeshLambertMaterial({ color: 0x999999 }),
    //     new MeshLambertMaterial({
    //         map: new TextureLoader().load('../img/rack_front.png'),
    //     }),
    //     new MeshBasicMaterial({
    //         map: new TextureLoader().load('../img/rack_back.png'),
    //     }),
    // ]);
    // men.name = 'men';
    // men.position.set(width / 2, 47, depth / 2);
    // men.layers.toggle(BLOOM_SCENE);

    // const group = new Group();
    // group.add(cab , men );
    return cab;
}
export {createCabinet}
